export default __webpack_public_path__ + "static/media/menu.8a5f9fd1.png";